<template>
    <div v-if="errors.length" class="error-container p-4">
        <div class="text-base text-[var(--charcoal-dark)] bg-[var(--primary-light)] rounded-2xl border border-[var(--bone)] shadow-[0px_1.4px_2.8px_0px_#0000000D] p-4">
            <p class="error-title text-base text-[var(--charcoal-dark)] font-bold mb-1">Please correct the following error(s):</p>
            <ul class="error-list ml-5 list-disc text-sm text-[var(--tone-gray)]">
                <li v-for="error in errors" :key="error" class="text-danger text-red-600">
                    {{ error }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ErrorList',
    props: {
        errors: { type: Array, default: () => [] }
    }
};
</script>